export const generateExchangeRates = (conversionRates, currencyOptions) => {
  return currencyOptions.map(option => {
    const currencyCode = option.currencyCode;
    const rateData = conversionRates.find(rate => rate.currency_code === currencyCode);    

    if (!rateData) return null;

    const buyRate = parseFloat(rateData.buy_rate).toFixed(2);
    const sellRate = parseFloat(rateData.sell_rate).toFixed(2);

    return {
      currency: currencyCode,
      name: option.currencyName,
      buying: `${option.symbol || ''}${buyRate}`,
      selling: `${option.symbol || ''}${sellRate}`,
      countryCode: option.countryCode.toUpperCase(),
    };
  }).filter(Boolean); // remove nulls
};
